import type { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const A_DAY = 1000 * 60 * 60 * 24;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // If the query fails, we don't want to retry
      retry: false,

      /**
       * As of now, the customer data is refresh daily
       * the data is considered stale 3 times a day
       */
      staleTime: A_DAY / 3,

      // don't refresh on windows focus
      refetchOnWindowFocus: false,
    },
  },
});

export function ReactQueryProvider({ children }: PropsWithChildren<{}>) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
